import React                                   from "react";
import PropTypes                               from 'prop-types';
import Flux                                    from "../../flux/Flux";
import Translations                            from "../../utils/Translations";
import {VXPay, VXPayAction}                    from "../../utils/VXPay";
import GlobalEventHandler                      from "../../utils/GlobalEventHandler";
import ProfileHeaderTicketLiveShow             from "./ProfileHeaderTicketLiveShow";
import VXButton                                from "../SimpleElements/VXButton/VXButton";
import {
    COLOR_TYPE_MOOD_3,
    COLOR_TYPE_MOOD_9,
    COLOR_TYPE_SUCCESS
}                                              from "../SimpleElements/VXButton/ButtonHelper";
import {VXButtonLineConfig, VXButtonLineStyle} from "../SimpleElements/VXButton/VXButtonConfig";
import STYLES                                  from "../SimpleElements/VXButton/EnumVXButton";
import VXButtonPrivateVideoCall                from "../SimpleElements/VXButton/Presets/VXButtonPrivateVideoCall";
import ReloadHelper                            from "../../utils/ReloadHelper";
import {TYPES}                                 from "../Loader/Loader";
import VideochatButtonWrapper                  from "../SimpleElements/VideochatButtonWrapper";


class ProfileHeaderButtons extends React.Component {

    static isServiceNumberItemBusy(serviceNumberItem) {
        return serviceNumberItem && serviceNumberItem.isBusy;
    }

    constructor(props) {
        super(props);

        this.state = {
            isActorOnline:           this.props.isActorOnline,
            freeShowData:            this.props.freeShowData,
            isLivePreviewEnabled:    this.props.isLivePreviewEnabled,
            isVoicecallActive:       Flux.Guest.isVoicecallActive(),
            isVoyeurChatAvailable:   this.props.isVoyeurChatAvailable,
            isCurrentlyTicketShow:   this.props.isCurrentlyTicketShow,
            isLobbyChat:             this.props.isLobbyChat,
            isService0900Busy:       ProfileHeaderButtons.isServiceNumberItemBusy(this.props.serviceNumberItem),
            isOnlineMobileVideocall: this.props.isOnlineMobileVideocall,
            singleC2CChatPrice:      this.props.singleC2CChatPrice,
        };

        this.onOnlineStateChange       = this.onOnlineStateChange.bind(this);
        this.onMessengerOpenClick      = this.onMessengerOpenClick.bind(this);
        this.isConversionChatAvailable = this.isConversionChatAvailable.bind(this);
        this.onConversionTimerEnd      = this.onConversionTimerEnd.bind(this);
        this.getVideoCallButton        = this.getVideoCallButton.bind(this);
        this.onVideocallClick          = this.onVideocallClick.bind(this);
        this.getContent                = this.getContent.bind(this);
    }

    componentDidMount() {
        Flux.Notification.addNotificationChangeListener(this.onOnlineStateChange);
        GlobalEventHandler.addListener(GlobalEventHandler.CONVERSION_CHAT_TIMER_ENDED, this.onConversionTimerEnd);
    }

    componentDidUpdate(prevProps) {
        if (this.props.actorId !== prevProps.actorId) {
            this.setState({
                isActorOnline:           this.props.isActorOnline,
                freeShowData:            this.props.freeShowData,
                isLivePreviewEnabled:    this.props.isLivePreviewEnabled,
                isVoicecallActive:       Flux.Guest.isVoicecallActive(),
                isVoyeurChatAvailable:   this.props.isVoyeurChatAvailable,
                isCurrentlyTicketShow:   this.props.isCurrentlyTicketShow,
                isLobbyChat:             this.props.isLobbyChat,
                isService0900Busy:       ProfileHeaderButtons.isServiceNumberItemBusy(this.props.serviceNumberItem),
                isOnlineMobileVideocall: this.props.isOnlineMobileVideocall,
                singleC2CChatPrice:      this.props.singleC2CChatPrice,
            });
        }
    }

    componentWillUnmount() {
        Flux.Notification.removeNotificationChangeListener(this.onOnlineStateChange);
        GlobalEventHandler.removeListener(GlobalEventHandler.CONVERSION_CHAT_TIMER_ENDED, this.onConversionTimerEnd);
    }

    isConversionChatAvailable() {
        return this.props.isActorAvailableForConversionChat && Flux.Guest.isEligibleForConversionChat();
    }

    onConversionTimerEnd() {
        this.forceUpdate();
    }

    setButtonConfig(data) {
        const config = {
            actorId: this.props.actorId,
            ...data
        };
        Flux.Button.setButtonConfig([config]);
    }

    onOnlineStateChange(notification) {
        const NotificationTypes = Flux.Constants.ApiTypes.Notification.Incoming;
        switch (notification.type) {
            case NotificationTypes.ACTOR_ONLINE:
                if (notification.actorId === this.props.actorId) {
                    let isCurrentlyTicketShow = this.state.isCurrentlyTicketShow;
                    if (this.state.isLobbyChat && !notification.isLobbyChat) {
                        isCurrentlyTicketShow = false;
                    }
                    const state = {
                        isActorOnline:           true,
                        isVoyeurChatAvailable:   notification.canVoyeurChat,
                        isLobbyChat:             notification.isLobbyChat,
                        isCurrentlyTicketShow,
                        isOnlineMobileVideocall: false,
                    };
                    this.setButtonConfig(state);
                    this.setState(state);
                }
                break;
            case NotificationTypes.ACTOR_OFFLINE:
                if (notification.actorId === this.props.actorId) {
                    const state = {
                        isActorOnline:           false,
                        isLobbyChat:             false,
                        isCurrentlyTicketShow:   false,
                        isOnlineMobileVideocall: notification.isOnlineMobileVideocall,
                        singleC2CChatPrice:      notification.singleC2CChatPrice,
                    };
                    this.setButtonConfig(state);
                    this.setState(state);
                }
                break;
            case NotificationTypes.ACTOR_SETTINGS:
                if (notification.actorId === this.props.actorId) {
                    const state = {
                        isLivePreviewEnabled: notification.isLivePreviewEnabled,
                    };
                    this.setButtonConfig(state);
                    this.setState(state);
                }
                break;
            case NotificationTypes.FREE_SHOW_START:
                if (notification.actorId === this.props.actorId) {
                    this.setState({
                        freeShowData: notification.data,
                    });
                }
                break;
            case NotificationTypes.FREE_SHOW_STOP:
                if (notification.actorId === this.props.actorId) {
                    this.setState({
                        freeShowData: null,
                    });
                }
                break;
            case NotificationTypes.VOICECALL_START :
                if (Flux.Guest.isLoggedIn()) {
                    const state = {
                        isVoicecallActive: true,
                    };
                    this.setButtonConfig(state);
                    this.setState(state);
                }
                break;
            case NotificationTypes.VOICECALL_STOP :
                if (Flux.Guest.isLoggedIn()) {
                    const state = {
                        isVoicecallActive: false,
                    };
                    this.setButtonConfig(state);
                    this.setState(state);
                }
                break;
            case NotificationTypes.SERVICE0900_STATUS_CHANGED :
                if (notification.actorId === this.props.actorId) {
                    this.setState({isService0900Busy: notification.isBusy});
                }
                break;
            default:
                break;
        }
    }

    onMessengerOpenClick(event) {
        event.preventDefault();

        // special logic for sender landing page: only redirect to profile instead of really executing an action (hard redirect also for mobile!)
        if (this.props.profileLink) {
            if (Flux.Guest.isLoggedIn()) {
                window.location.href = this.props.profileLink;
            } else {
                VXPay.openSignupOrLogin({},
                        new VXPayAction(Flux.Constants.ActionTypes.VXPay.REDIRECT_TO, {
                            targetUrl: this.props.profileLink,
                        }));
            }
        } else if (Flux.Guest.isLoggedIn()) {
            Flux.Messenger.selectChannelByActorId(this.props.actorId, true);
        } else {
            const action = new VXPayAction(Flux.Constants.ActionTypes.Messenger.SELECT_CHANNEL, {
                targetId: this.props.actorId,
            });

            if (Flux.Guest.isAnonymousVoicecall()) {
                VXPay.openSignup({
                    host:  this.props.actorId,
                    texts: {
                        BonusTextCustom: Translations.get('VoicecallVXPayTeasserText'),
                    },
                }, action);
            } else {
                VXPay.openSignupOrLogin({
                    host: this.props.actorId,
                }, action);
            }
        }
    }

    onVideocallClick() {
        if (Flux.Guest.isLoggedIn()) {
            if (this.props.profileLink) {
                ReloadHelper.reload(this.props.profileLink);
            } else {
                Flux.Special.showLoader(TYPES.DOT);
                Flux.NewMessenger.startChat(Flux.Constants.VXMessenger.ChatTypes.VIDEOCALL, this.props.actorId);
            }
        } else {
            // special logic for sender landing page: only redirect to profile instead of really executing an action (hard redirect also for mobile!)
            if (this.props.profileLink) {
                VXPay.openSignupOrLogin({},
                        new VXPayAction(Flux.Constants.ActionTypes.VXPay.REDIRECT_TO, {
                            targetUrl: this.props.profileLink,
                        }));
            } else {
                VXPay.openSignupOrLogin();
            }
        }
    }

    getVideoCallButton(withMargin = false) {
        return <VXButtonPrivateVideoCall
                price={this.state.singleC2CChatPrice}
                onClick={this.onVideocallClick}
                withMargin={withMargin}
        />;
    }

    getMessageButton() {
        return <button className={'actor-profile-header__btn-messenger btn--icon-detailed -click-material h-left'
                + ((!this.state.isVoicecallActive && this.state.isLivePreviewEnabled && !this.isConversionChatAvailable()) ? ' -live-preview-enabled' : '')
                + ((this.state.freeShowData) ? ' -free-show h-hide' : '')
                + ((this.state.isVoyeurChatAvailable || !this.isConversionChatAvailable()) ? ' -online' : '')
                + ((!this.state.isActorOnline) ? ' h-hide' : '')}
                       data-tip={Translations.get('TooltipWriteMessageButton')} data-place="top"
                       onClick={this.onMessengerOpenClick}
        >
            <div className="btn__text-container">
                <i className="icon -icon-chat-flat" />
                <span className="h-text-nowrap">{Translations.get('ActorProfileHeaderBtnTextchat')}</span>
                <span className="btn--icon-detailed__teaser h-text-nowrap">
                    {Flux.Guest.isLoggedIn() ? this.props.messagePrice : Translations.get('ChatButtonStartMessageSubline')}
                </span>
            </div>
        </button>;
    }

    getContent(messageButton, videochatButton, placeholderButton) {
        let content;
        if (this.state.isOnlineMobileVideocall && !Flux.Guest.isVoicecallActive()) {
            content = <div className="actor-profile-header__c2a actor-profile-header__c2a--grid">
                {messageButton}
                {this.getVideoCallButton()}
            </div>;
        } else if (!this.state.isActorOnline) {
            content =
                    <div className="actor-profile-header__c2a--offline clearfix">
                        {this.props.isPlaceholder ? placeholderButton : messageButton}
                    </div>;
        } else {
            content = <div className={`actor-profile-header__c2a clearfix`}>
                {videochatButton}
                {!this.isConversionChatAvailable() &&
                        <VideochatButtonWrapper actorId={this.props.actorId} type={Flux.Constants.VideochatButtonTypes.actorProfileLivePreview} />}
                {this.state.isVoyeurChatAvailable &&
                        <VideochatButtonWrapper actorId={this.props.actorId} type={Flux.Constants.VideochatButtonTypes.actorProfileVoyeurchat} />}
                {this.getMessageButton()}
                {this.props.serviceNumberItem && !this.state.isService0900Busy &&
                        <div className={"actor-profile-header__phone" + ((!this.state.isActorOnline) ? ' -is-disabled h-hide' : '')}>
                            <i className="icon -icon-phone-full" />
                            <span className="actor-profile-header__service-number">{this.props.serviceNumberItem.number}</span>
                            <br />
                            ({(this.props.serviceNumberItem.hint) ? this.props.serviceNumberItem.hint : this.props.serviceNumberItem.priceFormatted})
                        </div>
                }
                {this.props.serviceNumberItem && this.state.isService0900Busy &&
                        <div className={"actor-profile-header__phone" + ((!this.state.isActorOnline) ? ' -is-disabled h-hide' : '')}>
                            <i className="icon -icon-phone-full" />
                            <span className="actor-profile-header__service-number">{Translations.get('Service0900BusyTitle')}</span>
                            <br />
                            {Translations.get('Service0900BusyHint')}
                        </div>
                }

            </div>;
        }

        return content;
    }

    render() {
        const placeholderButton = (
                <VXButton
                        line1={[]}
                        line2={[]}
                        icon={''}
                        color={COLOR_TYPE_MOOD_9}
                        staticMode={true}
                        size={STYLES.SIZE.MEDIUM}
                        onClick={() => {
                        }}
                />
        );

        const messageButton = (
                <VXButton
                        line1={[new VXButtonLineConfig(Translations.get('ActorProfileHeaderBtnMessage'), new VXButtonLineStyle([STYLES.UPPERCASE]))]}
                        line2={[new VXButtonLineConfig(Flux.Guest.isLoggedIn() ? this.props.messagePrice : Translations.get('ChatButtonStartMessageSubline'))]}
                        icon={'-icon-chat-flat'}
                        color={this.state.isCurrentlyTicketShow || this.state.isOnlineMobileVideocall ? COLOR_TYPE_MOOD_3 : COLOR_TYPE_SUCCESS}
                        staticMode={true}
                        size={STYLES.SIZE.MEDIUM}
                        onClick={this.onMessengerOpenClick}
                />
        );

        const videochatButton = <VideochatButtonWrapper actorId={this.props.actorId}
                                                        type={Flux.Constants.VideochatButtonTypes.actorProfileVideochat} />;

        if (this.state.isCurrentlyTicketShow || this.state.isLobbyChat) {
            return <ProfileHeaderTicketLiveShow messageButton={messageButton}
                                                actorId={this.props.actorId}
                                                isMobile={false}
                                                onlyButton={this.props.onlyVideochatButton}
            />;
        }

        if (this.props.onlyVideochatButton) {
            if (this.state.isOnlineMobileVideocall && !Flux.Guest.isVoicecallActive()) {
                return <VideochatButtonWrapper actorId={this.props.actorId}
                                               type={Flux.Constants.VideochatButtonTypes.actorProfilePrivateVideoCall} />;
            }

            return videochatButton;
        }

        const content = this.getContent(messageButton, videochatButton, placeholderButton);

        return (
                <div className={`actor-profile-header__c2a-container ${this.state.isActorOnline ? "" : (this.props.isOnlineMobileVideocall ? "-is-videocall" : "-offline")} ${this.props.isLandingPage ? "-landing-page" : ""}${(this.props.isService0900Available && this.state.isActorOnline) ? "-is-service-number" : ""}`}>
                    {content}
                </div>
        );
    }
}

ProfileHeaderButtons.propTypes = {
    isVoyeurChatAvailable:             PropTypes.bool.isRequired,
    actorId:                           PropTypes.number.isRequired,
    actorName:                         PropTypes.string.isRequired,
    isActorOnline:                     PropTypes.bool.isRequired,
    isLivePreviewEnabled:              PropTypes.bool.isRequired,
    serviceNumberItem:                 PropTypes.shape({
        country:        PropTypes.string,
        hint:           PropTypes.string,
        isBusy:         PropTypes.bool,
        number:         PropTypes.string,
        priceFormatted: PropTypes.string,
    }),
    voyeurChatPrice:                   PropTypes.number,
    singleC2CChatPrice:                PropTypes.number,
    multiChatPrice:                    PropTypes.number,
    privateChatPrice:                  PropTypes.number,
    messagePrice:                      PropTypes.string || PropTypes.number,
    freeShowData:                      PropTypes.string,
    freeShowBegin:                     PropTypes.string,
    freeShowEnd:                       PropTypes.string,
    profileLink:                       PropTypes.string,
    voucherChatMinutes:                PropTypes.number,
    isActorAvailableForConversionChat: PropTypes.bool,
    isBannedCountryCode:               PropTypes.bool,
    actorLink:                         PropTypes.string,
    isCurrentlyTicketShow:             PropTypes.bool,
    onlyVideochatButton:               PropTypes.bool,
    isLobbyChat:                       PropTypes.bool,
    isOnlineMobileVideocall:           PropTypes.bool,
    isLandingPage:                     PropTypes.bool,
    isPlaceholder:                     PropTypes.bool,
    isService0900Available:            PropTypes.bool,
};

ProfileHeaderButtons.defaultProps = {
    isVoyeurChatAvailable:             true,
    actorId:                           0,
    actorName:                         '',
    multiChatPrice:                    0.00,
    isActorOnline:                     false,
    isLivePreviewEnabled:              false,
    freeShowData:                      null,
    profileLink:                       '',
    serviceNumberItem:                 null,
    voucherChatMinutes:                0,
    isActorAvailableForConversionChat: false,
    isBannedCountryCode:               false,
    isCurrentlyTicketShow:             false,
    onlyVideochatButton:               false,
    isLobbyChat:                       false,
    isOnlineMobileVideocall:           false,
    isLandingPage:                     false,
};

export default ProfileHeaderButtons;
